module.exports = __webpack_public_path__ + "img/txt_icon.98db6afb.svg";